// OrderPage.js

import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Divider,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Button,
} from "@mui/material";
import { Schedule } from "@mui/icons-material";
import { format } from "date-fns";
import { zhTW } from "date-fns/locale";
import getOrder from "../api/order/getOrder";
import { useNavigate, useParams } from "react-router-dom";
const OrderResultPage = () => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const retryTimer = useRef(null);
  var retryCount = 0;
  const navigate = useNavigate();
  const orderIdParam = useParams();
  const PAYMENT_STATUS = {
    Paid: "已付款",
    Unpaid: "尚未付款",
  };
  const fetchOrderDetails = async () => {
    setLoading(true);
    setError(null);
    retryCount = retryCount + 1;
    let order=null;
    try {
      const responseData = await getOrder(orderIdParam.orderId);
      if (responseData.code === "000") {
        order=responseData.order;
        setOrder(responseData.order);
      } else {
        throw new Error(responseData.message || "Unknown error occurred.");
      }
    } catch (err) {
      setError(err.message);
    } finally {

      if (retryTimer.current) {
        clearTimeout(retryTimer.current);
      }

      // Set a new timer
      retryTimer.current = setTimeout(() => {
        if (
          retryCount < 5 &&
          (order?.PaymentStatus !== PAYMENT_STATUS.Paid || error !== null)
        ) {
          fetchOrderDetails();
        }
      }, 3000);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchOrderDetails();

    // Cleanup function to clear timeout if component unmounts
    return () => {
      if (retryTimer.current) {
        clearTimeout(retryTimer.current);
      }
    };
  }, [orderIdParam.orderId]);
  const getDayInChinese = (date) => {
    const days = ["日", "一", "二", "三", "四", "五", "六"];
    const day = date.getDay();
    return days[day];
  };
  const formatDateToCustomString = (date) => {
    if (!(date instanceof Date)) {
      return "";
    }

    const monthDay = format(date, "MM/dd", { locale: zhTW });
    const chineseDay = getDayInChinese(date);
    const time = format(date, "HH:mm", { locale: zhTW });

    return `${monthDay}(${chineseDay}) ${time}`;
  };
  if (loading) {
    return <CircularProgress />;
  }
  const handleHomeClicked = () => {
    navigate(-1);
  };

  if (error) {
    return (
      <Container maxWidth="md">
        <Box my={5}>
          <Typography variant="h4" align="center">
            付款確認中…
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" my={2}>
          <Button
            color="info"
            variant="contained"
            onClick={() => navigate("/app")}
          >
            回首頁
          </Button>
        </Box>
      </Container>
    );
  }
  return (
    <Container maxWidth="md">
      <Box my={5}>
        <Typography variant="h4" align="center">
          {order?.PaymentStatus === PAYMENT_STATUS.Paid
            ? "付款完成"
            : "付款確認中…"}
        </Typography>
      </Box>
      <Grid item xs={12} sm={6}>
        <Card variant="outlined">
          <CardHeader title="訂位資訊" avatar={<Schedule />} />
          <Divider />
          <CardContent>
            <Typography variant="body1">店家名稱: {order.StoreName}</Typography>
            <Typography variant="body1">桌次: {order.TableName}</Typography>
            <Typography variant="body1">
              開始時間:{" "}
              {formatDateToCustomString(new Date(order.ReservationStartTime))}
            </Typography>
            <Typography variant="body1">
              結束時間:{" "}
              {formatDateToCustomString(new Date(order.ReservationEndTime))}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Box display="flex" justifyContent="center" my={2}>
        <Button color="info" variant="contained" onClick={handleHomeClicked}>
          回首頁
        </Button>
      </Box>
    </Container>
  );
};

export default OrderResultPage;
